/**
 * @module businessComponents\mdl\structureSelector
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Model } from "vue-property-decorator";
import { TreeNode } from "element-ui/types/tree";
import StructureNavigation from "../structureNavigation/structureNavigation";

@Component({
  components: {
    StructureNavigation
  }
})
export default class StructureSelector extends Vue {
  @Model("change")
  private value!: object;
  @Prop({ default: "请选择" })
  private btnText!: string;
  @Prop({ default: "选择归属：" })
  private title!: string;
  @Prop()
  private afterSubmit!: (item: TreeNode<string, IndexObject>) => void;

  private submit() {
    this.$emit("change", this.selected);
    if (this.afterSubmit && this.selected) {
      this.afterSubmit(this.selected);
    }
    this.menu = false;
  }
  private menu = false;
  private selected: TreeNode<string, IndexObject> | any = null;

  private get selectedName() {
    if (this.selected) {
      return this.selected.data.Name;
    }
    return "";
  }
}
